const PbxxRecord = require('../pbxx_record')

module.exports = class Retailer extends PbxxRecord {
  static get class_name() {
    return 'Retailer'
  }

  get has_facebook_page() {
    return !!this.facebook_pages.length
  }

  get has_twitter_account() {
    return !!this.twitter_accounts.length
  }

  add_to_retailer_account(retailer_account) {
    let _opts = {
	    basePath: retailer_account.resource_url
    }
    return this._mapper().add_to_retailer_account(this.id, _opts).then((response) => {
      retailer_account.retailers.push(this)
      this.retailer_account = retailer_account
      return this
    }, (error) => {
      throw(error)
    })
  }

}
